/* eslint-disable no-undef */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = async (entries, observer) => {
      if (!entries[0].isIntersecting) {
        return;
      }

      observer.unobserve(this);

      try {
        const response = await fetch(this.dataset.url);
        const text = await response.text();
        const div = document.createElement("div");

        div.innerHTML = text;

        const recommendations = div.querySelector("#product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (div.querySelector(".product-recommendations__slide")) {
          this.dataset.loaded = "true";
          this.dataset.slider = "product-recommendations";
        }

        this.initSlider();
      } catch (error) {
        window.console.error(error);
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 200px 0px",
    }).observe(this);
  }

  initSlider() {
    const sliderPlaceholder = this.querySelector("[data-slider]");

    const slider = new Glide(
      sliderPlaceholder,
      window.Syatt.config.glide.options[sliderPlaceholder.dataset.slider]
    );

    slider.mount();
  }
}

customElements.define("product-recommendations", ProductRecommendations);
